import { Breadcrumbs } from "@sembark-travel/ui/router"
import { Helmet } from "react-helmet-async"
import {
	generatePath,
	useLocation,
	useNavigate,
} from "../../../../../router-utils"
import { UploadCabMetricPricesViaCSVForm } from "../../../../../DataDrive/Metric"
import { TSheetFolder } from "../../../../../DataDrive"

export default function MetricFileUploadPricePage() {
	const location = useLocation()
	const navigate = useNavigate()
	function navigateToList() {
		return navigate("/data-drive", {
			replace: true,
		})
	}
	const folderDetails: TSheetFolder | undefined = location.state?.folderDetails
	return (
		<>
			<Helmet>
				<title>Upload Transport Metric Prices</title>
			</Helmet>
			<Breadcrumbs
				title="Upload Metric Prices"
				items={[
					[generatePath("/data-drive"), "Data Drive"],
					["", "Upload CSV"],
				]}
			/>
			<UploadCabMetricPricesViaCSVForm
				folderDetails={folderDetails}
				onSuccess={navigateToList}
				onCancel={navigateToList}
			/>
		</>
	)
}
